module.exports = __webpack_public_path__ + "static/img/help_img.d43bd0d6.png";